module.exports = __webpack_public_path__ + "59081054f4a7e5a4359f681f26395917.svg";